import { Button, Col, Form, Icon, Modal, Row, Toast } from "@douyinfe/semi-ui";
import { IconComment, IconKey, IconMail, IconModalStroked, IconSendMsgStroked, IconUser, IconUserCardPhone } from "@douyinfe/semi-icons";
import "./index.css";
import React, { useEffect, useRef, useState } from "react";
import { ApiClient, ApiResp, LogInReq, User } from "../../api/ApiClient";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import { useNavigate } from "react-router-dom";
import { meetRoles } from "../../utils";

const apiClient = ApiClient.getDefault();
let logInDto = {} as LogInReq;
let captchaApi: FormApi;
export default function Login() {
  const [countdown, setCountdown] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  let captchaImageSrc = () => `${apiClient.endpoint + "/auth/captcha"}`;
  let userNameValidator = (
    values: Record<string, any>
  ): string | Record<string, any> => {
    let errors: Record<string, any> = {};
    if (!values["mobile"]) {
      errors["mobile"] = "请填写手机号";
    }
    if (!values["captcha"]) {
      errors["captcha"] = "请填写短信验证码";
    }
    return Object.keys(errors).length === 0 ? "" : errors;
  };

  let captchaValidator = (
    values: Record<string, any>
  ): string | Record<string, any> => {
    let errors: Record<string, any> = {};
    if (!values.captcha) {
      errors.captcha = "请填写验证码";
    }
    return Object.keys(errors).length === 0 ? "" : errors;
  };
  let nav = useNavigate();
  let [captchaVisible, setCaptchaVisible] = useState(false);
  let [submitting, setSubmitting] = useState(false);
  let [captchaImage, setCaptchaImage] = useState("");
  let captchaRef = useRef<HTMLImageElement>(null);

  let fetchCaptcha = async () => {
    setSubmitting(true);
    try {
      let captchaImage = await apiClient.getCaptchaImage();
      setCaptchaImage(captchaImage);
      setSubmitting(false);
    } catch (e) {
      setSubmitting(false);
    }
  };


  let sendCaptcha = async () => {
    let mobile = captchaApi.getValue("mobile");
    if (!mobile) {
      Toast.info('请输入手机号');
      return;
    }

    try {
      setIsLoading(true);
      const ret: any = await apiClient.request('/auth/sendCaptcha?mobile=' + mobile, 'POST', null, null);
      if ("ok" == ret.code) {
        setCountdown(60); // 60秒倒计时
        Toast.success('验证码已发送');
      }

    } catch (error) {
      Toast.error('发送验证码失败');
    } finally {
      setIsLoading(false);
    }
  };
  let handleUsernameSubmit = async (values: Record<string, any>) => {
    logInDto.mobile = values.mobile;
    logInDto.password = values.password;
    setCaptchaVisible(true);
    fetchCaptcha();
  };

  let getDefaultMenuKey = (admin: User) => {
    for (var i = 0; i < admin.menus.length; i++) {
      if (admin.menus[i].menus && admin.menus[i].menus.length > 0) {
        return admin.menus[i].menus[0].code;
      }
    }
  };

  let handleCaptchaSubmit = async () => {
    await captchaApi.validate();
    logInDto.captcha = captchaApi.getValue("captcha");
    logInDto.mobile = captchaApi.getValue("mobile");
    setSubmitting(true);

    try {
      await apiClient.logInSms(logInDto);
      let user = await apiClient.getCurrentAdmin();
      localStorage.setItem("username", user.data.username);
      localStorage.setItem("userId", String(user.data.id));
      localStorage.setItem("userRealName", user.data.name);
      localStorage.setItem("teamId", String(user.data.teamId));
      localStorage.setItem("teamName", user.data.teamName);
      localStorage.setItem("role", user.data.role);
      localStorage.setItem("city", user.data.city);
      let page = getDefaultMenuKey(user.data);
      console.log("page ", "login");
      nav("/" + page, { replace: true });
    } catch (e) {
      console.error("登录错误", e);
      let msg = (e as Error).message;

      setSubmitting(false);
    }
  };

  let handleCaptchaCancel = (values: Record<string, any>) => {
    setCaptchaVisible(false);
    setSubmitting(false);
  };

  let handleCaptchaImageClick = async () => {
    if (submitting) {
      return;
    }
    fetchCaptcha();
  };

  useEffect(() => {
    apiClient.setToken("");
    apiClient.initToken();
  }, []);
  let form = (
    <div className="login-form">
      <div className="title">你好 !</div>
      <div className="title-tips">欢迎来到CRM客户管理系统！</div>
      <Form
        getFormApi={(api) => (captchaApi = api)}
        onSubmit={handleCaptchaSubmit}
        validateFields={userNameValidator}
        render={({ formState, formApi, values }) => (
          <>
            <Form.Section text="系统登录">
              <Form.Input
                className="el-input"
                prefix={<IconUserCardPhone  />}
                trigger="blur"
                field="mobile"
                label="手机号"
                style={{ width: '350px' }}
              />
              <div className="form-group captcha-group">
                <Form.InputNumber
                  hideButtons={true}
                  className="el-input"
                  prefix={<IconComment  />}
                  type="number"
                  field="captcha"
                  label="短信验证码"
                  style={{ width: '250px' }}
                />
                <Button
                  theme="outline"
                  style={{ marginBottom: '25px',marginLeft: '10px' }}
                  onClick={sendCaptcha}
                  disabled={countdown > 0 || isLoading}
                >
                  {countdown > 0 ? `${countdown}秒后重试` : '获取验证码'}
                </Button>
              </div>
              <div className="login-form-footer">
                <Button
                  style={{ width: "350px" }}
                  type="secondary"
                  htmlType="submit"
                  theme="solid"
                  size="large"
                  loading={submitting}
                  onClick={handleCaptchaSubmit}
                >
                  登录
                </Button>
              </div>
            </Form.Section>
          </>
        )}
      ></Form>
    </div>
  );

  return (
    <div className="grip login-container">
      <Row>
        <Col lg={16} md={12} sm={24} xl={16} xs={24}></Col>
        <Col lg={8} md={12} sm={24} xl={8} xs={24}>
          {form}
        </Col>
      </Row>
    </div>
  );
}
